import * as projectsActions from './projectsActions';
import projectsReducer from './projectsReducer';
import projectsSagas from './projectsSagas';
import * as projectsSelectors from './projectsSelectors';
import * as projectsTransformers from './projectsTransformers';
import * as projectsTypes from './projectsTypes';

const { PROJECTS_REDUCER_KEY } = projectsTypes;

export {
  PROJECTS_REDUCER_KEY,
  projectsActions,
  projectsReducer,
  projectsSagas,
  projectsSelectors,
  projectsTransformers,
  projectsTypes,
};
